import { render, staticRenderFns } from "./NotsCount.vue?vue&type=template&id=6e938e08&scoped=true"
import script from "./NotsCount.vue?vue&type=script&lang=js"
export * from "./NotsCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e938e08",
  null
  
)

export default component.exports